import { putSonarObjectUsers } from '@api';
import { refreshCurrentInitiativeSummarySaga } from '../../initiatives/summary/get';
import { updateSonarObjectReferences } from '../_idMap/actions';
import { createPutAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const putCoreSonarObjectsUsersSlice = createPutAsyncSlice({
	additionalReceiveSteps: [
		{
			actionHandler: refreshCurrentInitiativeSummarySaga,
			type: SagaYieldType.Latest
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) =>
				updateSonarObjectReferences([
					{
						sonarObjectId: request.sonarObjectId,
						users: request.users
					}
				])
		]
	},
	name: 'CoreSonarObjectsUsers',
	receive: false,
	request: true,
	requestHandler: putSonarObjectUsers
});
